import hash from 'object-hash';
import moment from 'moment';

const hashOptions = {
    algorithm: 'sha1'
};
let uuid = null;

/**
 * access localStorage with a Cache API
 */
export class CacheUtils {

    static get uuid() {

        return uuid;
    }

    /**
     * set user
     */
    static set uuid(newUuid) {

        uuid = newUuid;
    }

    /**
     * check if a key exists in the cache
     *
     * @param {String} url
     * @param {*} payload
     * @return {Boolean}
     */
    static has(url, payload = {} ) {

        return !!CacheUtils.get(url, payload);
    }

    /**
     * get the value for a given url and payload
     *
     * @param {String} url
     * @param {*} payload
     */
    static get(url, payload = {}) {

        try {
            const {values, expired_at} = JSON.parse(window.localStorage.getItem(CacheUtils.key(url, payload)));

            if ( expired_at === 0 || moment(expired_at).isAfter(moment()) ) {
                return values;
            } else {
                CacheUtils.remove(url, payload);
                return null;
            }
        } catch (e) {
            CacheUtils.remove(url, payload);
            return null;
        }
    }

    /**
     * remove cached value
     *
     * @param {String} url
     * @param {*} payload
     */
    static remove (url, payload = {}) {

        CacheUtils.removeByKey(CacheUtils.key(url, payload));
    }

    /**
     * remove a cached value by string
     *
     * @param {String} key
     */
    static removeByKey(key) {

        window.localStorage.removeItem(key);
    }

    /**
     * store something in the cache
     *
     * @param {String} url
     * @param {*} values
     * @param {*} payload
     * @param {Integer} ttl in minutes
     */
    static put(url, values, payload = {}, ttl = 90) {

        try {

            return window.localStorage.setItem(
                CacheUtils.key(url, payload),
                JSON.stringify({
                    values,
                    expired_at: ttl === 0 ? 0 : moment().add(ttl, 'minutes'),
                })
            );
        } catch (e) {
            console.warn(e);
        }
    }

    /**
     * store something in cache forever
     *
     * @param {String} url
     * @param {*} payload
     */
    static forever(url, values, payload) {

        return CacheUtils.put(url, values, payload, 0);
    }

    /**
     * clear all cache entries made by this app
     */
    static flush() {

        const keys = Object.keys(window.localStorage);

        keys.forEach((key) => {
            if (/^cache_/.test(key)) {
                CacheUtils.removeByKey(key);
            }
        });
    }

    /**
     * get a key for a cache value
     *
     * @param {String} url
     * @param {*} payload
     */
    static key(url, payload = {}) {

        return `cache_${CacheUtils.hash({
            url,
            payload,
            uuid: CacheUtils.uuid,
        })}`;
    }

    /**
     * hash anything
     *
     * @param {*} value
     */
    static hash(value) {

        return hash(value, hashOptions);
    }
}


// WEBPACK FOOTER //
// ./shared/utils/CacheUtils.js